var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Cancel/White",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07106781,7.01040764 L14.6118055,0.469669914 C14.9046988,0.176776695 15.3795725,0.176776695 15.6724657,0.469669914 C15.9653589,0.762563133 15.9653589,1.23743687 15.6724657,1.53033009 L9.13172798,8.07106781 L15.6724657,14.6118055 C15.9653589,14.9046988 15.9653589,15.3795725 15.6724657,15.6724657 C15.3795725,15.9653589 14.9046988,15.9653589 14.6118055,15.6724657 L8.07106781,9.13172798 L1.53033009,15.6724657 C1.23743687,15.9653589 0.762563133,15.9653589 0.469669914,15.6724657 C0.176776695,15.3795725 0.176776695,14.9046988 0.469669914,14.6118055 L7.01040764,8.07106781 L0.469669914,1.53033009 C0.176776695,1.23743687 0.176776695,0.762563133 0.469669914,0.469669914 C0.762563133,0.176776695 1.23743687,0.176776695 1.53033009,0.469669914 L8.07106781,7.01040764 Z",
    id: "Combined-Shape",
    fill: "#8F9BBD",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseInactive);
export default __webpack_public_path__ + "static/media/close-inactive.3b22bb38e34ebb755b24a752ccc9703c.svg";
export { ForwardRef as ReactComponent };